export default {
  partner:
    'Stabilește comisionul tău de procesare Stripe sau confirmă o marjă de 0%. Până atunci, restaurantele tale care folosesc Stripe nu pot fi lansate.',
  partner_live_one:
    'Stabilește comisionul tău de procesare Stripe sau confirmă o marjă de 0%. Până atunci, restaurantele tale care folosesc Stripe nu pot fi lansate, iar restaurantul tău activ nu primește plăți online.',
  partner_live_few:
    'Stabilește comisionul tău de procesare Stripe sau confirmă o marjă de 0%. Până atunci, restaurantele tale care folosesc Stripe nu pot fi lansate, iar cele {{count}} restaurante active ale tale nu primesc plăți online.',
  partner_live_other:
    'Stabilește comisionul tău de procesare Stripe sau confirmă o marjă de 0%. Până atunci, restaurantele tale care folosesc Stripe nu pot fi lansate, iar cele {{count}} restaurante active ale tale nu primesc plăți online.',
  restaurant:
    'Plățile online sunt suspendate până când partenerul tău stabilește comisionul de procesare. Plățile în numerar funcționează în continuare.',
  cta: 'Setează comisionul de procesare',
};
